import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import './Hero.module.scss';

/**
 * Hero component for About Us page
 */
const FleetSalesHero = (props) => {
  const { fields } = props;
  const { title, image } = fields;

  // Helper function to get the appropriate image field
  const getImageField = (imageData, type = 'desktopImage') => {
    if (!imageData || !imageData.fields) return null;

    const imageField = imageData.fields[type];
    if (imageField && imageField.value) {
      return {
        src: imageField.value.src,
        alt: imageField.value.alt || '',
        width: imageField.value.width,
        height: imageField.value.height,
      };
    }
    return null;
  };

  // Get desktop and mobile images
  const desktopImage = getImageField(image, 'desktopImage');
  const mobileImageData = getImageField(image, 'mobileImage');
  return (
    <div className={'container about-us-hero'}>
      <div className={'wrapper'}>
        <div className={'image'}>
          {desktopImage && (
            <img
              src={desktopImage.src}
              alt={desktopImage.alt}
              width={desktopImage.width}
              height={desktopImage.height}
            />
          )}
        </div>
        <div className={'mobileImage'}>
          {mobileImageData && (
            <img
              src={mobileImageData.src}
              alt={mobileImageData.alt}
              width={mobileImageData.width}
              height={mobileImageData.height}
            />
          )}
        </div>
        <h1 className={'title'} data-aos="fade-up" data-aos-offset="100">
          <RichText field={title} />
        </h1>
      </div>
    </div>
  );
};

export default FleetSalesHero;
